import { definePreset } from '@primeuix/themes';
import { palette } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

export const primeNgPreset = definePreset(Lara, {
    //Your customizations, see the following sections for examples
    semantic: {
      primary:  palette('#2563EB'),
      colorScheme: {
        light: {
            primary: {
                color: '#2563EB',
                // inverseColor: 'green',
            },
            highlight: {
                background: '#F2E8FC',
                // focusBackground: '{zinc.700}',
                color: '#ffffff',
                // focusColor: '#ffffff'
            },

        },

     }
  }
});

